import { useMemo } from "react";

import { useTranslation } from "react-i18next";

import Loading from "../../../../loading";

import { isEmptyList, isEmptyObject } from "../../../../../utils/validators";

function UnregPlanCard(props) {
  const { loading } = props;

  const { t } = useTranslation();

  const title = useMemo(() => {
    return t(`plans.unreg.title`);
  }, [t]);

  const features = useMemo(() => {
    const features = t("plans.unreg.features");
    if (!isEmptyObject(features)) {
      return Object.values(features);
    }
    return [];
  }, [t]);

  return (
    <div className="unreg-plan-card__container">
      {loading && (
        <div className="unreg-plan-card__loading">
          <Loading />
        </div>
      )}
      <div className="unreg-plan-card__content">
        <div className="unreg-plan-card__header__container">
          <div className="unreg-plan-card__header__content">
            <span className="plan-icon icon icon-circle-alternate"></span>
            <span className="plan-title" title={title}>
              {title}
            </span>
            <div className="plan-price"></div>
            <div className="plan-button"></div>
          </div>
        </div>
        <div className="unreg-plan-card__body__container">
          <div className="unreg-plan-card__body__content">
            {!isEmptyList(features) && (
              <div className="plan-feature__list">
                {features.map((feature, idx) => (
                  <div key={idx} className="plan-feature__item">
                    <span className="item-icon icon icon-check-alternate"></span>
                    <span className="item-text">{feature}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UnregPlanCard;
